import { useCallback, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import SearchedComponent from "../../components/SearchedComponent";
import { fetchAllPillCountDataService } from "../../services/pillCountManagementService";
import { notifyError } from "../../utilities/helper";

const PillCountManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchedValue, setSearchedValue] = useState("");
  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllPillCountData(pageSize, page, access_token, debouncedSearch);
    }
  }, [page, pageSize, access_token, debouncedSearch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchedValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchedValue]);

  const getAllPillCountData = async (
    pageSize,
    page,
    access_token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllPillCountDataService(
        page + 1,
        pageSize,
        access_token,
        debouncedSearch
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.mesage);
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const columns = [
    {
      field: "subjectNumber",
      headerName: "Subject Number",
      width: 450,
      renderHeader: () => (
        <div className="grid-heading">{"Subject Number"}</div>
      ),
      renderCell: (params) => {
        const subjectNumber = params.row.subjectNumber;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/addUpdate-pill-count-management", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {subjectNumber}
          </button>
        );
      },
    },
    {
      field: "site",
      headerName: "Site",
      width: 450,
      renderHeader: () => <div className="grid-heading">{"Site"}</div>,
      renderCell: (params) => {
        const site = params.row.site;

        return <span className="data-font">{site}</span>;
      },
    },
    {
      field: "randomizedDate",
      headerName: "Randomized Date",
      width: 450,
      renderHeader: () => (
        <div className="grid-heading">{"Randomized Date"}</div>
      ),
      renderCell: (params) => {
        const randomizedDate = params.row.randomizedDate;

        return <span className="data-font">{randomizedDate}</span>;
      },
    },
  ];

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link className="bread-crumbs-link" to="/pill-count-management">
          Pill Count Management
        </Link>
        -{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%", margin: "0 auto" }}
      >
        <Grid2 item md={4}>
          <p className="page-heading">Pill Count Management</p>
        </Grid2>
        <Grid2 item md={8}>
          <div className="search-bar-container">
            <SearchedComponent
              searchedValue={searchedValue}
              handleSearch={handleSearch}
              placeholder={"Pill Count"}
            />
          </div>
        </Grid2>
      </Grid2>

      {load ? (
        <Loader />
      ) : (
        <StyledGridComp
          rows={rowData}
          columns={columns}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          length={rowLength}
        ></StyledGridComp>
      )}
      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button className="create-btn">Back</button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default PillCountManagement;
